<template>
    <div style="display:none"></div>
  </template>
  
  <script>
  export default {
    name: "wake-lock",

    data() {
      return {
        wakeLock: null,
        videoElement: null,
        usingVideoFallback: false,
      };
    },
  
    mounted() {
      this.requestWakeLock();
      document.addEventListener("visibilitychange", this.handleVisibility);
    },
  
    beforeDestroy() {
      document.removeEventListener("visibilitychange", this.handleVisibility);
      this.releaseWakeLock();
      this.removeVideoFallback();
    },
  
    methods: {
      async requestWakeLock() {
        // --- Try Official Wake Lock API ---
        if ("wakeLock" in navigator) {
          try {
            this.wakeLock = await navigator.wakeLock.request("screen");
            console.log("[WakeLock] Using official wake lock.");
  
            this.wakeLock.addEventListener("release", () => {
              console.log("[WakeLock] Released by system.");
            });
  
            return; // success → no fallback needed
          } catch (e) {
            console.warn("[WakeLock] Failed, falling back to video");
          }
        } else {
          console.warn("[WakeLock] API not supported, using fallback");
        }
  
        // --- Start fallback video trick ---
        this.enableVideoFallback();
      },
  
      releaseWakeLock() {
        if (this.wakeLock) {
          this.wakeLock.release().catch(() => {});
          this.wakeLock = null;
        }
      },
  
      handleVisibility() {
        if (document.visibilityState === "visible") {
          this.requestWakeLock();
        }
      },
  
      enableVideoFallback() {
        if (this.usingVideoFallback) return;
  
        const video = document.createElement("video");
        video.id = "wakelock-video";
        video.playsInline = true;
        video.muted = true;
        video.autoplay = true;
        video.loop = true;
        video.style.cssText =
          "position:fixed;opacity:0;width:1px;height:1px;pointer-events:none;bottom:0;left:0;z-index:-1;";
  
        // 1×1 pixel black silent mp4
        video.src =
          "data:video/mp4;base64,AAAAHGZ0eXBtcDQyAAAAAG1wNDFtcDQxaXNvbThtcDQxaXNvbXJvb3QAAAAAZmRlYwAAACxtZGF0AAAAIG1vb3YAAAAGbWRpYQAAACBtZGhkAAAAAQAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAQAAABxtaW5mAAAAFHZtaGQAAAAAAAABAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAACAAACSGRsc2QAAAAA";
  
        document.body.appendChild(video);
  
        this.videoElement = video;
        this.usingVideoFallback = true;
  
        console.log("[WakeLock] Video fallback enabled");
      },
  
      removeVideoFallback() {
        if (this.videoElement) {
          this.videoElement.pause();
          if (this.videoElement.parentNode) {
            this.videoElement.parentNode.removeChild(this.videoElement);
          }
          this.videoElement = null;
          this.usingVideoFallback = false;
        }
      },
    },
  };
</script>
  